import { useEffect, useState } from 'react';
import { fetchSubscriptionFeatures } from 'services/api/subscriptions';
import { SubscriptionFeatureListRow } from 'types/api/subscriptions';

const useSubscriptionFeatures = () => {
  const [features, setFeatures] = useState<SubscriptionFeatureListRow[]>([]);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const rows = await fetchSubscriptionFeatures();
        if (!cancelled) setFeatures(rows);
      } catch {
        // swallow — empty list on failure
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, []);

  return features;
};

export default useSubscriptionFeatures;
